import NewTabLink from '@components/utils/links/newTabLink';
import { PIMSTER_STATIC_CDN } from '@constants';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import {
    OutboundLinkContext,
    OutboundLinkDestinationCategory,
    OutboundLinkShape,
} from '@enums';
import { HStack, HStackProps } from '@lib/uikit';
import NextImage from 'next/legacy/image';
import { useRouter } from 'next/router';
import { FC } from 'react';

type Variant = 'light' | 'dark';

interface Props extends HStackProps {
    variant?: Variant;
    priority?: boolean;
}

const Text = styled.p<{ variant?: Variant }>`
    font: ${({ theme }) => theme.fonts.caption};
    color: ${({ theme, variant }) =>
        variant === 'light'
            ? theme.palette.common.white
            : theme.palette.text.secondary};
`;

const Link = styled(NewTabLink)`
    position: relative;
    aspect-ratio: 16 / 10;
    width: 3rem;
`;

const PoweredBy: FC<Props> = ({
    variant,
    priority = false,
    ...rest
}: Props) => {
    const { query } = useRouter();
    const campaignName = query.company;
    const pimsterURL = `https://pimster.app?utm_source=pim&utm_campaign=${campaignName}&utm_medium=footer`;
    const theme = useTheme();

    const logoVariant =
        variant || theme.palette.mode === 'dark' ? 'light' : 'dark';

    return (
        <HStack
            aria-label='Made by Pimster'
            justifyContent='center'
            spacing='xxs'
            {...rest}
        >
            <Text variant={variant}>Powered by</Text>
            <Link
                href={pimsterURL}
                destination_name='Pimster Landing Page'
                destination_category={
                    OutboundLinkDestinationCategory.PimsterDocument
                }
                shape={OutboundLinkShape.Visual}
                context={OutboundLinkContext.Footer}
            >
                <NextImage
                    priority={priority}
                    src={`${PIMSTER_STATIC_CDN}/brand/logo/logo-transparent-${logoVariant}.png`}
                    alt='Pimster'
                    layout='fill'
                    objectFit='contain'
                    sizes={'3rem'}
                />
            </Link>
        </HStack>
    );
};

export default PoweredBy;
